<template>
  <div class="schoolRoam">
    <iframe :src="this.src" frameborder="0" width="100%" height="100%" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      src: ''
    }
  },
  mounted() {
    if (this.$route.query.src) {
      this.src = this.$route.query.src
    }
  }
}
</script>

<style lang="scss" scoped>
.schoolRoam{
  height: 100%;
  width: 100%;
  padding: 20px;
}
</style>
